import React, { useState } from "react";
import "./nav.css";
import NavMobileIcon from "./MobileNav";

//create a functional component named Nav
const Nav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="">
      <header class="brand-background-color brand-darkened-border banner h-24 w-screen md:w-full fixed top-0 md:top-10 z-50  xl:border-b-5 bg-blue-primary">
        <div class="h-full flex flex-wrap justify-between items-center lg:justify-center">
          <a class="brand  lg:mr-8 xl:mr-16 xxl:mr-24 p-1" href="/">
            <img
              class="header-logo"
              src="https://onetrusthomeloans.com/wp-content/uploads/2021/12/OTHL-logo.png"
              alt="OneTrust Home Loans"
            />
          </a>
          <div class="nav-mobile-icon h-8 w-16 relative lg:hidden">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <nav class="mt-16 md:mt-0 brand-background-color brand-darkened-border flex w-0 absolute right-0 border-t overflow-scroll lg:overflow-visible lg:h-full lg:w-auto lg:relative lg:border-0 lg:top-0">
            <div class="menu-primary-nav-container">
              <ul
                id="menu-primary-nav"
                class="overflow-hidden list-none flex flex-col justify-center pl-0 m-12  lg:overflow-visible lg:h-full lg:flex-row lg:items-center lg:m-0"
              >
                <li
                  id="menu-item-997"
                  class="h-full whitespace-no-wrap menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children relative"
                >
                  <a
                    class="brand-background-color-hover-darkened flex items-center text-white text-18 sm:text-21 xl:text-18 xxl:text-19 font-bold mb-2 px-8 py-2 md:mb-0 lg:px-4 lg:h-full xxl:px-8 w-full border-solid border-b border-white lg:border-none"
                    href="/home-loan-options/"
                  >
                    Loan Programs
                  </a>
                  <ul class="sub-menu list-none m-0 mb-8 hover:block focus-within:block lg:hidden lg:absolute lg:right-3 lg:left-0 lg:w-108 lg:px-2 lg:py-4 lg:z-10 xl:border-t-5 xl:border-transparent">
                    <li
                      id="menu-item-996"
                      class="h-full whitespace-no-wrap menu-item menu-item-type-post_type menu-item-object-page"
                    >
                      <a
                        class="brand-background-color-hover-darkened flex items-center text-white text-15 sm:text-18 xl:text-15 xxl:text-16 font-normal mb-2 px-8 py-2 md:mb-0 lg:px-4 lg:h-full xxl:px-8"
                        href="/home-loan-options/"
                      >
                        Home Loan Options
                      </a>
                    </li>
                    <li
                      id="menu-item-995"
                      class="h-full whitespace-no-wrap menu-item menu-item-type-post_type menu-item-object-page"
                    >
                      <a
                        class="brand-background-color-hover-darkened flex items-center text-white text-15 sm:text-18 xl:text-15 xxl:text-16 font-normal mb-2 px-8 py-2 md:mb-0 lg:px-4 lg:h-full xxl:px-8"
                        href="/portfolio-loans/"
                      >
                        Portfolio Loans
                      </a>
                    </li>
                  </ul>
                </li>
                <li
                  id="menu-item-205"
                  class="h-full whitespace-no-wrap menu-item menu-item-type-post_type menu-item-object-page"
                >
                  <a
                    class="brand-background-color-hover-darkened flex items-center text-white text-18 sm:text-21 xl:text-18 xxl:text-19 font-bold mb-2 px-8 py-2 md:mb-0 lg:px-4 lg:h-full xxl:px-8"
                    href="/our-mission/"
                  >
                    About Us
                  </a>
                </li>
                <li
                  id="menu-item-2791"
                  class="h-full whitespace-no-wrap menu-item menu-item-type-post_type menu-item-object-page"
                >
                  <a
                    class="brand-background-color-hover-darkened flex items-center text-white text-18 sm:text-21 xl:text-18 xxl:text-19 font-bold mb-2 px-8 py-2 md:mb-0 lg:px-4 lg:h-full xxl:px-8"
                    href="/mortgage-calculators/"
                  >
                    Mortgage Calculators
                  </a>
                </li>
                <li
                  id="menu-item-2754"
                  class="h-full whitespace-no-wrap menu-item menu-item-type-post_type menu-item-object-page"
                >
                  <a
                    class="brand-background-color-hover-darkened flex items-center text-white text-18 sm:text-21 xl:text-18 xxl:text-19 font-bold mb-2 px-8 py-2 md:mb-0 lg:px-4 lg:h-full xxl:px-8"
                    href="/contact-us/"
                  >
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
            <span class="w-16"></span>
            <a
              class="h-16 my-auto brand-background-color-hover-darkened hidden border border-white xl:flex xl:items-center xl:text-white xl:text-18 xxl:text-19 xl:font-bold xl:py-4 xl:px-2 xxl:px-4"
              href="/schedule-consultation"
            >
              Schedule a Consultation
            </a>
          </nav>
        </div>
        <NavMobileIcon
          menuOpen={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span />
          <span />
          <span />
        </NavMobileIcon>
      </header>
      {menuOpen ? (
        <div className="nav-slide absolute z-[100] max-w-[10px]">
          <div className="lg:hidden fixed right-0 top-20 z-20 w-1/2">
            <ul className="list-none right-0 pt-10 top-20 bg-blue-primary z-50 px-4  pb-96 h-full">
              <li
                id="menu-item-997"
                class="h-full whitespace-no-wrap menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children relative"
              >
                <a
                  class="brand-background-color-hover-darkened flex items-center text-white text-18 sm:text-21 xl:text-18 xxl:text-19 font-bold mb-2 px-8 py-2 md:mb-0 lg:px-4 lg:h-full xxl:px-8 w-auto lg:w-full border-solid border-b border-white lg:border-none"
                  href="/home-loan-options/"
                >
                  Loan Programs
                </a>
                <ul class="sub-menu list-none m-0 mb-8 hover:block focus-within:block lg:hidden lg:absolute lg:right-3 lg:left-0 lg:w-108 lg:px-2 lg:py-4 lg:z-10 xl:border-t-5 xl:border-transparent">
                  <li
                    id="menu-item-996"
                    class="h-full whitespace-no-wrap menu-item menu-item-type-post_type menu-item-object-page"
                  >
                    <a
                      class="brand-background-color-hover-darkened flex items-center text-white text-15 sm:text-18 xl:text-15 xxl:text-16 font-normal mb-2 px-8 py-2 md:mb-0 lg:px-4 lg:h-full xxl:px-8"
                      href="/home-loan-options/"
                    >
                      Home Loan Options
                    </a>
                  </li>
                  <li
                    id="menu-item-995"
                    class="h-full whitespace-no-wrap menu-item menu-item-type-post_type menu-item-object-page"
                  >
                    <a
                      class="brand-background-color-hover-darkened flex items-center text-white text-15 sm:text-18 xl:text-15 xxl:text-16 font-normal mb-2 px-8 py-2 md:mb-0 lg:px-4 lg:h-full xxl:px-8"
                      href="/portfolio-loans/"
                    >
                      Portfolio Loans
                    </a>
                  </li>
                </ul>
              </li>
              <li
                id="menu-item-205"
                class="h-full whitespace-no-wrap menu-item menu-item-type-post_type menu-item-object-page"
              >
                <a
                  class="brand-background-color-hover-darkened flex items-center text-white text-18 sm:text-21 xl:text-18 xxl:text-19 font-bold mb-2 px-8 py-2 md:mb-0 lg:px-4 lg:h-full xxl:px-8"
                  href="/our-mission/"
                >
                  About Us
                </a>
              </li>
              <li
                id="menu-item-2791"
                class="h-full whitespace-no-wrap menu-item menu-item-type-post_type menu-item-object-page"
              >
                <a
                  class="brand-background-color-hover-darkened flex items-center text-white text-18 sm:text-21 xl:text-18 xxl:text-19 font-bold mb-2 px-8 py-2 md:mb-0 lg:px-4 lg:h-full xxl:px-8"
                  href="/mortgage-calculators/"
                >
                  Mortgage Calculators
                </a>
              </li>
              <li
                id="menu-item-2754"
                class="h-full whitespace-no-wrap menu-item menu-item-type-post_type menu-item-object-page"
              >
                <a
                  class="brand-background-color-hover-darkened flex items-center text-white text-18 sm:text-21 xl:text-18 xxl:text-19 font-bold mb-2 px-8 py-2 md:mb-0 lg:px-4 lg:h-full xxl:px-8"
                  href="/contact-us/"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Nav;
